import { IDEA_ATTRIBUTE_TYPES, DeviceTypes } from './consts';

export const defaultIdeaAttributes = [
  IDEA_ATTRIBUTE_TYPES.SOURCE,
  IDEA_ATTRIBUTE_TYPES.KEYWORD,
  IDEA_ATTRIBUTE_TYPES.AVERAGE_SEARCH_VOLUME,
  IDEA_ATTRIBUTE_TYPES.SEARCH_VOLUME_TREND,
  IDEA_ATTRIBUTE_TYPES.SUGGESTED_BID,
  IDEA_ATTRIBUTE_TYPES.COMPETITION,
  IDEA_ATTRIBUTE_TYPES.RELEVANCE,
  IDEA_ATTRIBUTE_TYPES.AD_IMPRESSION_SHARE,
];

export const defaultIdeaAggregations = [{
  AggregationKey: 'GroupInfo',
  AggregationValues: [
    {
      IdeaAttribute: 'Keywords',
      AggregationType: 'Merge',
    },
    {
      IdeaAttribute: 'AverageSearchVolume',
      AggregationType: 'Sum',
    },
    {
      IdeaAttribute: 'SearchVolumeTrend',
      AggregationType: 'Sum',
    },
    {
      IdeaAttribute: 'SuggestedBid',
      AggregationType: 'Average',
    },
    {
      IdeaAttribute: 'Relevance',
      AggregationType: 'Average',
    },
    {
      IdeaAttribute: 'AdImpressionShare',
      AggregationType: 'Average',
    },
    {
      IdeaAttribute: 'Competition',
      AggregationType: 'Average',
    },
  ],
}];

export const defaultDevicesTypeIds = [
  DeviceTypes.Desktop,
  DeviceTypes.Mobile,
  DeviceTypes.Tablet,
];

export const defaultIdeaOverview = [
  {
    IdeaAttribute: 'SearchVolumeTrend',
  },
  {
    IdeaAttribute: 'CompetitorAdImpressionShare',
  },
  {
    IdeaAttribute: 'MarketLeaderAdImpressionShare',
  },
  {
    IdeaAttribute: 'AverageSearchVolume',
    Segment:
    {
      '@odata.type': '#Model.Suggestions.DeviceSegment',
      Devices: defaultDevicesTypeIds,
    },
  },
  {
    IdeaAttribute: 'SearchVolumeTrend',
    Segment:
    {
      '@odata.type': '#Model.Suggestions.DeviceSegment',
      Devices: ['Mobile'],
    },
  },
];
